import { User, Therapist} from "../types/user";

export interface TimeSlot {
    time: string;
    available: boolean;
  }
  
  export interface DateAvailability {
    date: string;
    hasSlots: boolean;
  }
  
  export interface Appointment {
    id: string;
    therapistId: string;
    patientId: string;
    date: string;
    status: 'scheduled' | 'completed' | 'cancelled';
    therapist: Therapist;
    patient: User;
    createdAt: string;
    updatedAt: string;
  }
  
  export const fetchMonthAvailability = async (
    therapistId: string, 
    startDate: Date, 
    endDate: Date
  ): Promise<DateAvailability[]> => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/appointments/month-availability?` +
      `therapistId=${therapistId}&` +
      `startDate=${startDate.toISOString().split('T')[0]}&` +
      `endDate=${endDate.toISOString().split('T')[0]}`
    );
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch month availability');
    }
    
    return response.json();
  };
  
  export const fetchAvailableSlots = async (
    therapistId: string, 
    date: Date
  ): Promise<TimeSlot[]> => {
    const formattedDate = date.toISOString().split('T')[0];
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/appointments/available-slots?` +
      `therapistId=${therapistId}&` +
      `date=${formattedDate}`
    );
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to fetch available slots');
    }
    
    return response.json();
  };
  
  export const bookAppointment = async (
    therapistId: string, 
    date: Date, 
    time: string
  ): Promise<Appointment> => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Vous devez être connecté pour prendre rendez-vous');
    }
  
    const formattedDate = date.toISOString().split('T')[0];
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/appointments`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify({
        therapistId,
        date: formattedDate,
        time,
      }),
    });
  
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to book appointment');
    }
  
    return response.json();
  };